import "./styles.css";
export function Card(props) {
  const img_src = props.src;
  const name = props.name;
  const position = props.position;

  return (
    <div key={name} className="people_slot">
      <img className="people_img" src={img_src} alt={`${name} - ${position}`} />
      <strong className="title">{name}</strong>
      <p className="gallery_img location">{position}</p>
    </div>
  );
}
